var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2797",
    "data-name": "Group 2797",
    transform: "translate(1884 -5949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2795",
    "data-name": "Group 2795",
    transform: "translate(-1884 5949)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_5e4dfb017603e07e43dd81fe8b8aecec",
    "data-name": "5e4dfb017603e07e43dd81fe8b8aecec",
    d: "M26.76,11.661a.913.913,0,0,1,.874.413.887.887,0,0,1,0,.956.913.913,0,0,1-.874.413H25.476V16.8a5.87,5.87,0,0,1-1.749,4.186,6.025,6.025,0,0,1-4.237,1.735h-.981a.9.9,0,1,1,0-1.794h.981A4.153,4.153,0,0,0,23.622,16.8h0V13.443h-3.4v1.34a2.792,2.792,0,0,1-.834,1.987,2.866,2.866,0,0,1-2.013.823H10.44a2.829,2.829,0,0,1-2.847-2.811h0v-1.34H4.236V16.8a4.153,4.153,0,0,0,4.18,4.126H9.458a.9.9,0,1,1,0,1.794H8.477A6.02,6.02,0,0,1,2.419,16.8h0V13.443H1.013A.913.913,0,0,1,.14,13.03a.887.887,0,0,1,0-.956.913.913,0,0,1,.874-.413H26.76Zm-9.4-6.53a2.866,2.866,0,0,1,2.013.823,2.792,2.792,0,0,1,.834,1.987h0V9.484a.32.32,0,0,1-.1.241.329.329,0,0,1-.244.094H7.932a.329.329,0,0,1-.244-.094.321.321,0,0,1-.1-.241h0V7.941A2.829,2.829,0,0,1,10.44,5.131h6.918ZM19.491,0A6.018,6.018,0,0,1,25.44,5.98h0V7.26a.909.909,0,0,1-1.817,0h0V5.98a4.1,4.1,0,0,0-1.186-2.94,4.206,4.206,0,0,0-2.946-1.247h-.981A.9.9,0,0,1,17.6.9a.9.9,0,0,1,.909-.9h.981ZM9.4,0a.915.915,0,0,1,.909.9.915.915,0,0,1-.909.9H8.416a4.208,4.208,0,0,0-2.977,1.23,4.1,4.1,0,0,0-1.2,2.956h0V7.26a.915.915,0,0,1-.909.9H3.316l-.122-.01a.9.9,0,0,1-.775-.887h0V5.98a6.019,6.019,0,0,1,6-5.98H9.4Z",
    transform: "translate(10.099 12.624)",
    fill: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanicon);
export default __webpack_public_path__ + "static/media/scanicon.f9e156ea8434327e9da6ab8c3bdb5a37.svg";
export { ForwardRef as ReactComponent };